import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Gtp } from 'src/app/shared/gtp';
import { GruposReferenciasTablaComponent } from '../grupos-referencias-tabla/grupos-referencias-tabla.component';
import { GruposReferenciasService } from 'src/app/services/admin/grupos-referencias/grupos-referencias.service';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-grupo-referencia',
  templateUrl: './grupo-referencia.component.html',
  styleUrls: ['./grupo-referencia.component.scss']
})
export class GrupoReferenciaComponent implements OnInit {

  public loading: boolean = false;
  //public showAlertMsg: boolean = false;
  public alertFail: boolean = false;
  public alertSuccess: boolean = false;

  public alertMsg: string = '';
  public vertabla: boolean = false;

  public editar: boolean = false;
  public guardar: boolean = true;
  public cancelar: boolean = false;

  grupos = {
    id: null,
    cod_cliente: null,
    usuario:null,
    tipo: null,
    descripcion: '',
    observacion: '',
  }

  gruposFiltered=[
    {id: 1, nombre:'Visible solo para mi'},
    {id: 2, nombre:'Visible para otros otros usuarios'}
  ]

  constructor(
    private router: Router,
    private gtp: Gtp,
    private grupoRef: GruposReferenciasService,

  ) {}

  ngOnInit(): void {
      this.cargarFormData();
      let user = this.gtp.getUserDataParse();
      this.grupos.cod_cliente = user['cod_cliente'];
      this.grupos.usuario = user['username'];
  }

  closeForm(){
    //this.router.navigate(['/inicio/flota'])
    this.gtp.setAdminSidebar(true);
  }

  getGrupoSelected(e){
    this.grupos.tipo=e.id
  }

  cargarFormData(){
    this.grupoRef.getFormDataObs().subscribe(res => {
      console.log(res)
      this.guardar=false
      this.editar=true
      this.cancelar=true
      this.grupos.id = res.id
      this.grupos.descripcion = res.descripcion
      this.grupos.observacion = res.observacion
    });
  }

  doGuardar(){
    this.loading = true;

    if (this.grupos.descripcion == '') {
      this.alertFail = true;
      this.alertMsg = 'Ingrese la Descripción';
    }else{
      this.grupoRef.postGruposReferenciasListar(this.grupos).subscribe(res => {
        console.log(res)

        this.alertMsg = 'PUNTO CREADO';
        this.alertSuccess = true;
      }, function(error){
          //console.log(error);
          this.alertMsg = error;
          this.alertFail = true;
          this.loading = false;
          return;
      });
    }



    setTimeout(() => {
      //this.showAlertMsg = false;
      this.doCancelar()
      this.alertSuccess = false;
      this.alertFail = false;
      this.loading = false;
    }, 2000)

  }

  doEditar(){
    Swal.fire(
      'Buen Trabajo!',
      'Grupo de Referencia Actualizado correctamente',
      'warning'
    )
  }

  doCancelar(){
    this.grupos.cod_cliente = null
    this.grupos.usuario = null
    this.grupos.tipo = null
    this.grupos.descripcion = ''
    this.grupos.observacion = ''

    this.editar = false
    this.cancelar = false
    this.guardar = true
    this.vertabla = false
    this.gtp.setMainOutlet(false); //Ocultamos lo que tenemos en el outlet

  }

  toggleTable(e){
    //console.log(e)
    this.vertabla = e.checked
    if ( this.vertabla) {
      this.gtp.setMainOutlet(GruposReferenciasTablaComponent);
    } else {
      this.gtp.setMainOutlet(false);
    }
  }

  closeMovil(){
    this.gtp.setAdminSidebar(true);
  }

}
